import { getTokenClientes } from "../Store/storages/AuthenticationStorage";
import { apiClientes } from "../config/api";
import { Address } from "../interfaces/entities/Cancelamento/PassoCartaCancelamento/Address";
import { Contrato } from "../interfaces/entities/Cancelamento/PassoSelecioneBeneficiarios/Contrato";
import { Procedimento } from "../interfaces/entities/ClassificacaoProcedimentos/Procedimento";
import { PermissaoDeclaracao } from "../interfaces/entities/DeclaracaoPermanencia/PermissaoDeclaracao";
import { HistoricoCancelamento } from "../interfaces/entities/HistoricoCancelamento";
import { Response } from "../interfaces/services/Response";
import { SolicitacaoReanalise } from "../interfaces/entities/ReanaliseNegativa/SolicitacaoReanalise";
import { Anexo } from "../interfaces/entities/Reembolso/Anexo";
import { ContatoOption } from "../interfaces/entities/ReanaliseNegativa/ContatoOption";
import { getMimeType } from "../utils/MimeType";
import { sanitizeFileName } from "../utils/SanitizeFileName";

export const getUtilizacaoServico = async (periodo: string): Promise<Response | null> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await apiClientes.get(`/contrato/getutilizacaoservico?dtCompet=01/${periodo}`, { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
      resolve(response);
    } catch (error: any) {
      reject(error.response);
    }
  })
};


export const getListaCancelamentos = async (): Promise<HistoricoCancelamento[]> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await apiClientes.get(`/Contrato/ListaSolicCancelContr`, { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
      resolve(
        response.data.map((item: any) => {
          const beneficiario = item.beneficiario.split(' ');
          const codigoBeneficiario = beneficiario[0];
          const nomeBeneficiario = beneficiario.slice(2).join(' ');
          return {
            protocolo: item.protocolo,
            data: item.dtOperInic,
            codigoBeneficiario,
            nomeBeneficiario,
            motivo: item.descrTipoExclUsrContr,
            formaSolic: item.descrMeioSolic
          }
        })
      );
    } catch (error: any) {
      reject(error.response);
    }
  })
};

export const getSimulacao = async (): Promise<Response | null> => {
  try {
    const response = await apiClientes.get('/Contrato/GetSimulacao',
      { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
    return response;
  } catch (error: any) {
    console.log({ error });
    return error.response;
  }
};

export const getVerifUsrCandid = (): Promise<PermissaoDeclaracao> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await apiClientes.get('/Contrato/VerifUsrCandid',
        { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });

      if (response?.data?.isRestrRelat !== undefined) {
        resolve({
          permitido: !response.data.isRestrRelat,
          mensagem: response.data.msg
        })
      } else {
        reject("Não foi possível obter as informações do usuário");
      }
    } catch (error: any) {
      console.log({ error });
      reject(error);
    }
  })
}

export const getCoberturasContratuais = async (pCodProced: string): Promise<Response | null> => {
  try {
    const response = await apiClientes.get(`/Contrato/GetCoberturasContratuais?pCodProced=${pCodProced}`,
      { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
    return response;
  } catch (error: any) {
    console.log({ error });
    return error.response;
  }
};

export const getSeguroViagem = async (): Promise<Response | null> => {
  try {
    const response = await apiClientes.get(`/Contrato/GetSeguroViagem`,
      { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
    return response;
  } catch (error: any) {
    console.log({ error });
    return error.response;
  }
};

export const passoMotivoCancelamento = async (tipoCancelamento: string): Promise<Response | null> => {
  try {
    const response = await apiClientes.get(`/Contrato/PassoMotivoCancelamento`,
      { headers: { Authorization: `Bearer ${await getTokenClientes()}` }, params: { tipoCancelamento } });
    return response;
  } catch (error: any) {
    console.log({ error });
    return error.response;
  }
};

export const enviarEmailPosVenda = async (telefone: string, email: string, mensagem: string): Promise<Response | null> => {
  try {
    const response = await apiClientes.post('/Contrato/EnviarEmailPosVenda', {
      email,
      telefone,
      mensagem
    }, { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
    return response;

  } catch (error: any) {
    console.log({ error });
    return error.response;
  }
};

export const enviarRetencaoPf = async (telefone: string, email: string, motivoCancelamento: string,  lstContrato: Contrato[], tipoCancelamento: string): Promise<Response | null> => {
  try {
    const response = await apiClientes.post('/Contrato/EnviarRetencaoPf', {
      motivoCancelamento,
      telefone,
      email,
      lstContrato,
      tipoCancelamento
    }, { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
    return response;

  } catch (error: any) {
    console.log({ error });
    return error.response;
  }
};

export const passoSelecioneBeneficiario = async (indProdutoCoop: string, tipoCancelamento: string, motivoCancelalmento: string): Promise<Response | null> => {
  try {
    const response = await apiClientes.post('/Contrato/PassoSelecioneBeneficiario', {
      indProdutoCoop,
      tipoCancelamento,
      motivoCancelalmento
    }, { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
    return response;

  } catch (error: any) {
    console.log({ error });
    return error.response;
  }
};

export const passoFormaEnvioConfirmacao = async (motivoCancelamento: string, lstContrato: Contrato[], tipoCancelamento: string): Promise<Response | null> => {
  try {
    const response = await apiClientes.post('/Contrato/PassoFormaEnvioConfirmacao', {
      motivoCancelamento,
      lstContrato: lstContrato.map((contrato) => ({
        codTipoUsr: contrato.codTipoUsr,
        codStatusUsr: contrato.codStatusUsr,
        idUsrContr: contrato.idUsrContr
      })),
      tipoCancelamento
    }, {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` }
    });
    return response;

  } catch (error: any) {
    console.log({ error });
    return error.response;
  }
};

export const passoAceiteTermo = async (email?: string, postal?: Address | {}): Promise<Response | null> => {
  try {
    const response = await apiClientes.post('/Contrato/PassoAceiteTermo', {
      postal: postal,
      email: {
        email: email || ""
      }
    }, {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` }
    });
    return response;

  } catch (error: any) {
    console.log({ error });
    return error.response;
  }
};

export const passoFinalizacao = async (
  indRN195: boolean,  formaEnvio: string, motivoCancelamento: string, lstIdUsrContr: number[], indCancelContr: boolean
): Promise<Response | null> => {
  try {
    const response = await apiClientes.post('/Contrato/PassoFinazalicao', {
      indCancelContr,
      indRN195,
      formaEnvio,
      motivoCancelamento,
      lstIdUsrContr
    }, {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` }
    });
    return response;

  } catch (error: any) {
    console.log({ error });
    return error.response;
  }
};

export const getListaProcs = async (descricao?: string): Promise<Procedimento[]> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await apiClientes.get(`/Contrato/ListProcSimpSofist?descr=${descricao || ''}`,
        { headers: { Authorization: `Bearer ${await getTokenClientes()}` }
      });

      if (response?.data) {
        resolve(response.data.map((r: { codTipoCobert: any; descr: any; classificacao: any; }) => ({
          tipoCobertura: r.codTipoCobert,
          descricao: r.descr,
          classificacao: r.classificacao
        })))
      } else {
        reject(response);
      }
    } catch (error) {
      reject(error);
    }
  })
};

export const solicitarReanaliseNegativa = async (solicitacaoReanalise: SolicitacaoReanalise): Promise<Response | null> => {
  try {
    const response = await apiClientes.post('/Contrato/SolicitarReanaliseNegativa', {
      numSolicitacao: Number(solicitacaoReanalise.numSolicitacao),
      observacao: solicitacaoReanalise.observacao,
      hash: solicitacaoReanalise.file?.arquivo,
      contenttype: solicitacaoReanalise.file?.tipoArquivo,
      filename: solicitacaoReanalise.file ? sanitizeFileName(solicitacaoReanalise.file?.nomeArquivo) : undefined,
    }, {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` }
    });
    return response;

  } catch (error: any) {
    console.log({ error });
    return error.response;
  }
};

export const getHistOcorOuvidor = async (): Promise<Response | null> => {
  try {
    const response = await apiClientes.get(`/Contrato/HistOcorOuvidor`,
      { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
    return response;
  } catch (error: any) {
    console.log({ error });
    return error.response;
  }
};